@if (mode$|async; as mode) {
  <nav #nav class="p-4 -mb-18 w-full sticky z-50 bg-white -top-px transition duration-300 ease-in-out"
    [ngClass]="isIntersecting ? 'bg-opacity-0' : 'bg-opacity-100 shadow-2xl'">
    <div class="flex items-center" [@visibility]="mode === ModeRead ? 'visible' : 'hidden'">
      <div class="flex-prd-header flex items-center overflow-hidden min-w-8">
        <app-button appNavigateBack class="mr-4" ariaLabel="Terug" (click)="backBtnClicked.emit()">
          <img alt="" src="/assets/icons/icon-16-arrow-left.svg" class="h-4 w-4">
        </app-button>
        <div class="transition duration-300 truncate" [ngClass]="isIntersecting ? 'opacity-0' : 'opacity-100'">{{ title }}</div>
      </div>
      @if (collectionIds$|async; as ids) {
        <app-project-reference-carousel class="flex-initial"
          [ids]="ids" [dark]="!isIntersecting"
          [@visibility]="mode === ModeRead ? 'visible' : 'hidden'">
        </app-project-reference-carousel>
      }
      <div class="flex-prd-header shrink-0 flex items-center">
        <app-badge class="text-xs ml-auto mr-6" badgeType="primary">
          {{ state }}
        </app-badge>
        <app-button class="mr-2" ariaLabel="Bewerken" id="edit-ref" (click)="setEditMode()" *appHasRoleAndKvwNumber="{ roles:[authorities.editor], kvwNumber}">
          <img alt="" src="/assets/icons/vwui-edit.svg" class="h-4 w-4">
        </app-button>
        <app-button (click)="showDownloadModal()" id="project-download-button">
          <img alt="" src="/assets/icons/vwui-import.svg" class="h-4 w-4">
        </app-button>
      </div>
    </div>
    <div class="absolute flex items-center inset-0 p-4" [@visibility]="mode === ModeEdit ? 'visible' : 'hidden'">
      <div class="transition duration-300" [ngClass]="isIntersecting ? 'opacity-0' : 'opacity-100'">Pagina bewerken</div>
      <vwui-button class="ml-auto is-light-primary border border-neutral-3 rounded" id="close-edit-ref" (click)="setReadMode()">
        Bewerkmodus sluiten
      </vwui-button>
      @if (showPublish) {
        <vwui-button class="is-primary ml-1" (appThrottledClick)="publishClicked.emit()">
          Pagina publiceren
        </vwui-button>
      }
      @if (showConcept) {
        <vwui-button class="is-primary ml-1" (appThrottledClick)="conceptClicked.emit()">
          Pagina concept
        </vwui-button>
      }
    </div>
  </nav>
}
